// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import StoreProductWarrantyLookupState from "@store/Framework/Store/Store/Pages/ProductWarrantyLookup/StoreProductWarrantyLookupState";
import { WarrantyResult } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: StoreProductWarrantyLookupState = {
    data: null,
    modelNumbers: null,
    type: 0,
    searchQuery: "",
    isLoadingModels: false,
    isLoadingData: false,
};

const actions = {
    "Store/Pages/ProductCatalogs/BeginWarrantyLookup": (draft: Draft<StoreProductWarrantyLookupState>) => {
        draft.isLoadingModels = true;
    },
    "Store/Pages/ProductWarrantyLookup/SetModels": (
        draft: Draft<StoreProductWarrantyLookupState>,
        action: { response: WarrantyResult },
    ) => {
        draft.modelNumbers = action.response.modelNumbers;
        draft.type = 0;
        draft.isLoadingModels = false;
        if (Object.keys(action.response).length === 0) {
            draft.type = 2;
        }
    },
    "Store/Pages/ProductCatalogs/BeginWarrantyLookupData": (draft: Draft<StoreProductWarrantyLookupState>) => {
        draft.isLoadingData = true;
    },
    "Store/Pages/ProductWarrantyLookup/SetWarranty": (
        draft: Draft<StoreProductWarrantyLookupState>,
        action: { response: WarrantyResult },
    ) => {
        draft.data = action.response.data;
        draft.type = 1;
        draft.isLoadingData = false;
        draft.isLoadingModels = false;
    },
    "Store/Pages/ProductWarrantyLookup/SetSearchQuery": (
        draft: Draft<StoreProductWarrantyLookupState>,
        action: { searchQuery: string },
    ) => {
        draft.searchQuery = action.searchQuery;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreProductWarrantyLookupActions = Parameters<typeof reducer>[1];
export default reducer;
